export default __webpack_public_path__ + "static/media/141o.569ae1e5.svg";